import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { Its2Constants } from '@apps/its2/its2.constants';
import { AppConstants } from '@apps/app.constants';
import { BaseListApiService } from '@common/api/base-list-api.service';
import { ResultApi } from '@common/api/result-api';
import { CmdbAssetApi } from './models';

@Injectable({
    providedIn: 'root'
})
export class CmdbAssetListApiService extends BaseListApiService<CmdbAssetApi>
{
    constructor (http: HttpClient)
    {
        super(http);

        this.segmentRoot = AppConstants.Configuration.apiUrlIts2;
        this.resourceUrl = `/${Its2Constants.BaseApi}/assets`;
    }

    getAssets (qs: string): Observable<ResultApi<CmdbAssetApi>>
    {
        if (AppConstants.IsDataLocal('its2'))
        {
            return this.http.get<ResultApi<CmdbAssetApi>>('assets/data/its2/assets.json');
        }

        return this.getAll(`${this.resourceUrl}${qs}`);
    }
}